<div class="modal-content">
  <div class="header">
    <h3>Delete Alert</h3>
    <img
      src="assets/icons/close-sm.svg"
      alt=""
      (click)="modal.deny(undefined)"
    />
  </div>
  <div class="content">
    <p>Are you sure you want to delete this alert?</p>
  </div>
  <div class="ctrl-btns">
    <button class="cancel" (click)="modal.deny(undefined)">Cancel</button>
    <button (click)="modal.approve()" class="delete">Yes</button>
  </div>
</div>
